import { useState } from "react"

import createContextFactory from "@Utils/factory"

const { Provider, useContext } = createContextFactory(useTableResize)

export {
  useContext as useTableResizeContext,
  Provider as TableResizeProvider,
}

function useTableResize() {
  const [columnWidths, setColumnWidths] = useState({})
  const [activeResizeColumn, setActiveResizeColumn] = useState(null)
  const [resizedColumns, setResizedColumns] = useState([])

  return {
    columnWidths,
    setColumnWidths,
    activeResizeColumn,
    setActiveResizeColumn,
    resizedColumns,
    setResizedColumns,
  }
}
